module.exports = __webpack_public_path__ + "static/img/userAvatar.6808cf3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/pblCourse/userAvatar.png
// module id = SifN
// module chunks = 4